
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import monitorKpiModal from "../monitor-kpi-modal/monitor-kpi-modal.vue";
import customModal from "../customModal/customModal.vue";
import riskpopup from "./riskpopup.vue"
import CreateSchedulePopup from "./CreateSchedulePopup.vue"
export default {
  components: {
    customModal,
    monitorKpiModal,
    riskpopup,
    CreateSchedulePopup
  },
  name: "RbqmDashboardApex",
  data() {
    return {
      siteId:"",
      siteCodeforpopup:"",
      overallRiskScore: 0,
      averageriskscore: 0,
      highriskitems:[],
      riskitemsbykpi:[],
      kpianalysed:0,
      uniqueRiskNames:[],
      uniqesitecodes:[],
      kpiriskarray:[],
      defaultriskname:"",
      sitestudyriskname:"",
      defaultsite:"",
      Category:"",
      showpop:false,
      createschedulemodel: false,
      kpiriskpopup: false,
      popupheadder:"",
      lastRun: "15-Jan-2026",
      performanceList: [],
      kpis: [
        { name: "", level: "high", sitesImpacted: 0 },
        { name: "", level: "medium", sitesImpacted: 0 },
        { name: "", level: "low", sitesImpacted: 0 },
      ],
kpiTrendSeries: [],
      kpiTrendOptions: {
        chart: {
          type: "bar",
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            borderRadius: 4,
          },
        },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 1 },
        xaxis: {
          categories: [],
          labels: { rotate: -45 },
          title: { text: "Date" },
        },
        yaxis: {
          title: { text: "Score" },
        },
        tooltip: {
          x: { show: true },
        },
      },
studyBenchmarkLoading: false,

    studyBenchmarkSeries: [
      {
        name: "Risk Score",
        data: [], // y-axis
      },
    ],

    studyBenchmarkOptions: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [], // siteCode
        title: {
          text: "Site Code",
        },
        labels: {
          rotate: -45,
        },
      },
      yaxis: {
        title: {
          text: "Score",
        },
        min: 0,
      },
      tooltip: {
        y: {
          formatter: (val) => `Score: ${val}`,
        },
      },
    },
      baseapi: process.env.VUE_APP_Service_URL,
      kpiWithScores: [],
      openModal: false
    };
  },
  mounted() {
    this.listSitePerformance();
    this.getriskscoreitem();
    window.addEventListener("studyIdChanged", (event) => {
      console.log("StudyIDChanged into" + event.detail.storage);
      this.listSitePerformance();
      this.getriskscoreitem();
    });

  },
  methods: {
     formatDateYMD(input) {
      if (!input) return "";
      const d = new Date(input);
      if (isNaN(d.getTime())) return "";
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`; 
    },
    openhighriskpopup(){
      this.showpop = true;
    },
    closehighriskpopup(){
      this.showpop = false;
      this.kpiriskpopup = false;
    },
    customcolor(score) {
      let intscore = parseInt(score);
      if (intscore >= 20) {
        return "inround highrisk";
      }
      else if (intscore >= 10) {
        return "inround mediumrisk";
      }
      else {
        return "inround safe";
      }

    },
    formatRunDate(date) {
      if (!date) return "-";
      return moment.utc(date).local().format("DD-MM-YYYY");
    },
    async viewDocument(kpiWithScores, siteId, siteCode) {
      this.siteCodeforpopup = siteCode;
      this.siteId = siteId;
      this.kpiWithScores = kpiWithScores;
      this.openModal = true;
    },
    closeModal() {
      this.openModal = false;
    },
    async listSitePerformance() {
      const idtoken = store.getters.getIdToken;
      this.studyId = store.getters.getStudyIs;
      axios
        .get(`${this.baseapi}/forms/rbqm/getriskscorestudysitesummary?studyId=${this.studyId}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.performanceList = res.data;
           this.uniqesitecodes = [
      ...new Set(
        this.performanceList
          .map(item => item?.siteCode)
          .filter(Boolean)
      )
    ];
    this.defaultsite = this.uniqesitecodes[0];

        })
        .catch(async (err) => {
          console.log(err);
        });
    },
    calcAverage(arr) {
  if (!arr.length) return 0;
  const sum = arr.reduce((a, b) => a + b, 0);
  return +(sum / arr.length).toFixed(2);
},
   async benchmarklinefun() {
  const idtoken = store.getters.getIdToken;
  this.studyId = store.getters.getStudyIs;

  try {
    const res = await axios.get(
      `${this.baseapi}/forms/rbqm/getriskscoreitem?StudyId=${this.studyId}&DataScope=Study&Category=${this.sitestudyriskname}&RecordType=Risk`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    const entities = res?.data?.data?.entities || [];

    const scores = entities
      .map((it) => Number(it?.score))
      .filter((v) => Number.isFinite(v) && v > 0);

    if (!scores.length) {
      const emptyAnn = { yaxis: [] };

      this.studyBenchmarkOptions = {
        ...this.studyBenchmarkOptions,
        annotations: emptyAnn,
      };

      this.$refs?.studyBenchmarkChart?.updateOptions(
        { annotations: emptyAnn },
        false,
        true
      );
      return;
    }

    const avgScore = this.calcAverage(scores);
    console.log("average for benchmark = ", avgScore);

    const ann = {
      yaxis: [
        {
          y: avgScore,
          borderColor: "#FF9800",
          strokeDashArray: 6,
          label: {
            borderColor: "#FF9800",
            style: { color: "#fff", background: "#FF9800", fontSize: "12px" },
            text: `Benchmark Avg: ${avgScore}`,
          },
        },
      ],
    };

    this.studyBenchmarkOptions = {
      ...this.studyBenchmarkOptions,
      annotations: ann,
    };

    this.$refs?.studyBenchmarkChart?.updateOptions(
      { annotations: ann },
      false,
      true
    );
  } catch (err) {
    console.log(err);
  }
},

     async sitestudybenchmarkfun() {
    const idtoken = store.getters.getIdToken;
    this.studyId = store.getters.getStudyIs;

    this.studyBenchmarkLoading = true;

    try {
      const res = await axios.get(
        `${this.baseapi}/forms/rbqm/getriskscoreitem?StudyId=${this.studyId}&DataScope=Site&Category=${this.sitestudyriskname}&RecordType=Risk`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      );

      const entities = res?.data?.data?.entities || [];

      // ✅ filter + map
      const rows = entities
        .map((it) => {
          const score = Number(it?.score);
          if (!Number.isFinite(score) || score <= 0) return null;

          const siteCode =
            it?.siteCode === null || it?.siteCode === ""
              ? " "
              : String(it.siteCode);

          return { siteCode, score };
        })
        .filter(Boolean);

      // optional: sort by score desc
      rows.sort((a, b) => b.score - a.score);

      // ✅ ApexCharts binding
      this.studyBenchmarkOptions.xaxis.categories = rows.map(
        (r) => r.siteCode
      );
      this.studyBenchmarkSeries[0].data = rows.map((r) => r.score);
      
    } catch (err) {
      console.log(err);
    } finally {
      this.studyBenchmarkLoading = false;
      this.benchmarklinefun();
    }
  },
    async getriskscoreitem() {
      const idtoken = store.getters.getIdToken;
      this.studyId = store.getters.getStudyIs;

      try {
        const res = await axios.get(
          `${this.baseapi}/forms/rbqm/getriskscoreitem?StudyId=${this.studyId}&DataScope=Study&IsLatest=true&SortProperty=score&SortOrder=1&RecordType=Risk`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const entities = res?.data?.data?.entities || [];
        this.highriskitems = entities;
        this.uniqueRiskNames = [
      ...new Set(
        entities
          .map(item => item?.riskName)
          .filter(Boolean)
      )
    ];
    
        this.Category = entities[0].riskName;
        this.defaultriskname = entities[0].riskName;
        this.sitestudyriskname = entities[0].riskName;
        this.kpianalysed = res?.data?.data?.totalCount||0;
        this.overallRiskScore = entities.reduce((sum, item) => {
          return sum + (Number(item.score) || 0);
        }, 0);
        let aversgescore = this.overallRiskScore/entities.length;
        this.averageriskscore = aversgescore.toFixed(2);
        this.getriskscoreitembykpi();
        console.log("Overall Risk Score:", this.overallRiskScore);

      } catch (err) {
        console.log(err);
      }
    },
    formatDateTimeLabel(input) {
  if (!input) return "";
  const d = new Date(input);
  if (isNaN(d.getTime())) return "";

  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
},

async kpitrendgraph() {
  const idtoken = store.getters.getIdToken;
  this.studyId = store.getters.getStudyIs;

  const siteCode = encodeURIComponent(this.selectedSiteCode || "Site 101");
  const category = encodeURIComponent(this.Category || "Missing visits");

  try {
    const res = await axios.get(
      `${this.baseapi}/forms/rbqm/getriskscoreitem?StudyId=${this.studyId}&SiteCode=${this.defaultsite}&Category=${this.defaultriskname}&DataScope=Site&RecordType=Risk`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    const entities = res?.data?.data?.entities || [];
    const cleaned = entities
      .map((it) => {
        const y = Number(it?.score);
        const ts = new Date(it?.CreatedAt).getTime();

        if (!Number.isFinite(y) || y <= 0) return null;
        if (!Number.isFinite(ts)) return null;

        return {
          ts,
          label: this.formatDateTimeLabel(it?.CreatedAt),
          y,
          isLatest: !!it?.isLatest,
        };
      })
      .filter(Boolean);

    const latestCandidates = cleaned.filter((r) => r.isLatest);
    const latest =
      latestCandidates.length > 0
        ? latestCandidates.sort((a, b) => a.ts - b.ts)[latestCandidates.length - 1]
        : null;

    const history = cleaned
      .filter((r) => !r.isLatest)
      .sort((a, b) => a.ts - b.ts);

    let finalRows = [];
    if (latest) {
      const lastHistory = history.slice(-2);
      finalRows = [...lastHistory, latest];
    } else {
      finalRows = history.slice(-3);
    }

    const categories = finalRows.map((r) => r.label);
    const values = finalRows.map((r) => r.y);

    this.kpiTrendSeries = [{ name: "Score", data: values }];

    this.kpiTrendOptions = {
      ...this.kpiTrendOptions,
      chart: { ...this.kpiTrendOptions.chart, type: "bar" },
      xaxis: {
        type: "category",
        categories,
        title: { text: "Date & Time" },
        labels: { rotate: -45, trim: false },
      },
      yaxis: { title: { text: "Score" } },
      tooltip: { x: { show: true } },
    };
  } catch (err) {
    console.log(err);
    this.kpiTrendSeries = [];
  }
},
     async getriskscoreitembykpi() {
  const idtoken = store.getters.getIdToken;
  this.studyId = store.getters.getStudyIs;

  try {
    const res = await axios.get(
      `${this.baseapi}/forms/rbqm/getriskscoreitem?StudyId=${this.studyId}&Category=${encodeURIComponent(this.Category)}&DataScope=Site&IsLatest=true&RecordType=Risk`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    const entities = res?.data?.data?.entities || [];
    this.riskitemsbykpi = entities;
    // Count risk levels (High/Medium/Low)
   const grouped = entities.reduce(
  (acc, item) => {
    const lvl = String(item?.riskLevelLabel || "").trim().toLowerCase();

    if (lvl === "high") {
      acc.high.count += 1;
      acc.high.sites.push(item);
    } else if (lvl === "medium") {
      acc.medium.count += 1;
      acc.medium.sites.push(item);
    } else if (lvl === "low") {
      acc.low.count += 1;
      acc.low.sites.push(item);
    }

    return acc;
  },
  {
    high: { count: 0, sites: [] },
    medium: { count: 0, sites: [] },
    low: { count: 0, sites: [] },
  }
);

// Rewrite KPIs using API counts + this.Category as name
const kpiName = this.Category || "KPI";

this.kpis = [
  { name: kpiName, level: "high", sitesImpacted: grouped.high.count, sites: grouped.high.sites },
  { name: kpiName, level: "medium", sitesImpacted: grouped.medium.count, sites: grouped.medium.sites },
  { name: kpiName, level: "low", sitesImpacted: grouped.low.count, sites: grouped.low.sites },
];
    this.kpitrendgraph();
    this.sitestudybenchmarkfun();
  } catch (err) {
    console.log(err);
  }
},
async openkpipopup(sites, risklevel){
  let headder = "";
  if(risklevel == "high"){
    headder = "High Risk Items"
  }
  else if(risklevel == "medium"){
     headder = "Medium Risk Items"
  }
  else{
    headder = "Low Risk Items"
  }
  this.kpiriskpopup = true;
  this.popupheadder = headder;
  this.kpiriskarray = sites;
console.log("kpi sites", sites);
},
opencreateschdule(){
this.createschedulemodel = true;
},
    riskLabel(score) {
      if (score >= 20) return "High Risk";
      if (score >= 10) return "Medium Risk";
      return "Low Risk";
    },
    riskClass(score) {
      if (score >= 20) return "risk-high";
      if (score >= 10) return "risk-medium";
      return "risk-low";
    },
    riskbadgeClass(score) {
      if (score >= 20) return "badge-danger";
      if (score >= 10) return "badge-warning";
      return "badge-success";
    },
    prettyLevel(level) {
      if (level === "high") return "High";
      if (level === "medium") return "Medium";
      return "Low";
    },
  },
};